export default __webpack_public_path__ + "static/media/find-location.881c68f6.svg";